// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageStrip-module--wrapper--ZXimy","text":"ImageStrip-module--text--38CHD"};